import { EmuVariable } from '../../types/emu';

export const EMU_INFO_DATA = [
    {
        Cluster: 0,
        fill: '#E1E1E1',
        description:
            'Epipelagic, Moderate to Cool, Euhaline, Oxic, Medium Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 1,
        fill: '#E1E1E1',
        description:
            'Mesopelagic, Cold, Polyhaline, Severely Hypoxic, Low Nitrate, Medium Phosphate, High Silicate',
    },
    {
        Cluster: 2,
        fill: '#E1E1E1',
        description:
            'Epipelagic, Cold, Polyhaline, Hypoxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 3,
        fill: '#708cd9',
        description:
            'Bathypelagic, Very Cold, Euhaline, Severely Hypoxic, High Nitrate, Medium Phosphate, High Silicate',
    },
    {
        Cluster: 4,
        fill: '#E1E1E1',
        description:
            'Mesopelagic, Cold, Polyhaline, Severely Hypoxic, Low Nitrate, High Phosphate, High Silicate',
    },
    {
        Cluster: 5,
        fill: '#a0d7d1',
        description:
            'Epipelagic, Superchilled, Polyhaline, Highly Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 6,
        fill: '#E1E1E1',
        description:
            'Epipelagic, Cold, Polyhaline, Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 7,
        fill: '#E1E1E1',
        description:
            'Epiplagic, Moderate to Cool, Mesohaline, Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 8,
        fill: '#ccb0ba',
        description:
            'Epipelagic, Moderate to Cool, Euhaline, Oxic, Medium Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 9,
        fill: '#c5b6d0',
        description:
            'Mesopelagic, Moderate to Cool, Euhaline, Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 10,
        fill: '#7570e6',
        description:
            'Mesopelagic, Cold, Euhaline, Severely Hypoxic, High Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 11,
        fill: '#cabfd9',
        description:
            'Epipelagic, Moderate to Cool, Euhaline, Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 12,
        fill: '#E1E1E1',
        description:
            'Epipelagic, Very Cold, Mesohaline, Severely Hypoxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 13,
        fill: '#364799',
        description:
            'Bathypelagic, Very Cold, Euhaline, Hypoxic, High Nitrate, Medium Phosphate, High Silicate',
    },
    {
        Cluster: 14,
        fill: '#465290',
        description:
            'Bathypelagic, Very Cold, Euhaline, Oxic, High Nitrate, Low Phosphate, High Silicate',
    },
    {
        Cluster: 15,
        fill: '#E1E1E1',
        description:
            'Bathypelagic, Cold, Polyhaline, Anoxic, Low Nitrate, High Phosphate, High Silicate',
    },
    {
        Cluster: 16,
        fill: '#E1E1E1',
        description:
            'Epipelagic, Very Cold, Mesohaline, Highly Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 17,
        fill: '#E1E1E1',
        description:
            'Epipelagic, Cold, Mesohaline, Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 18,
        fill: '#eb96cc',
        description:
            'Epipelagic, Warm to Very Warm, Euhaline, Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 19,
        fill: '#b9caf6',
        description:
            'Epipelagic, Cold, Euhaline, Oxic, Medium Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 20,
        fill: '#E1E1E1',
        description:
            'Epipelagic, Very Cold, Mesohaline, Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 21,

        fill: '#ebbccd',
        description:
            'Epipelagic, Warm to Very Warm, Euhaline, Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 22,
        fill: '#E1E1E1',
        description:
            'Epipelagic, Cold, Mesohaline, Hypoxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 23,
        fill: '#a0d7d1',
        description:
            'Epipelagic, Frozen/Superchilled, Euhaline, Highly Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 24,
        fill: '#eba9d4',
        description:
            'Epipelagic, Warm to Very Warm, Euhaline, Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 25,
        fill: '#a0d7d1',
        description:
            'Epipelagic, Frozen/Superchilled, Euhaline, Highly Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 26,
        fill: '#9365e6',
        description:
            'Mesopelagic, Moderate to Cool, Euhaline, Hypoxic, Medium Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 27,
        fill: '#E1E1E1',
        description:
            'Epipelagic, Very Cold, Polyhaline, Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 28,
        fill: '#E1E1E1',
        description:
            'Epiplagic, Moderate to Cool, Mesohaline, Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 29,
        fill: '#4792c9',
        description:
            'Bathypelagic, Very Cold, Euhaline, Oxic, Medium Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 30,
        fill: '#b4d7e7',
        description:
            'Epipelagic, Very Cold, Euhaline, Oxic, Medium Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 31,
        fill: '#9ad4e6',
        description:
            'Epipelagic, Frozen/Superchilled, Euhaline, Oxic, Medium Nitrate, Low Phosphate, Medium Silicate',
    },
    {
        Cluster: 32,
        fill: '#E1E1E1',
        description:
            'Epipelagic, Warm to Very Warm, Mesohaline, Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 33,
        fill: '#7591ff',
        description:
            'Mesopelagic, Very Cold, Euhaline, Severely Hypoxic, High Nitrate, Medium Phosphate, Medium Silicate',
    },
    {
        Cluster: 34,
        fill: '#E1E1E1',
        description:
            'Mesopelagic, Very Cold, Polyhaline, Anoxic, Low Nitrate, High Phosphate, High Silicate',
    },
    {
        Cluster: 35,
        fill: '#9edbff',
        description:
            'Epipelagic, Frozen/Superchilled, Euhaline, Oxic, Low Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 36,
        fill: '#1a52aa',
        description:
            'Bathypelagic, Very Cold, Euhaline, Oxic, Medium Nitrate, Low Phosphate, Low Silicate',
    },
    {
        Cluster: 37,
        fill: '#4792c9',
        description:
            'Bathypelagic, Very Cold, Euhaline, Oxic, High Nitrate, Low Phosphate, Medium Silicate',
    },
];

export const EMU_UNITS: Record<EmuVariable, string> = {
    Temperature: String.fromCodePoint(8451),
    Salinity: '',
    'Dissolved O2': 'ml/l',
    Phosphate: 'µmol/l',
    Nitrate: 'µmol/l',
    Silicate: 'µmol/l',
};

export const EMU_GLOBAL_SUMMARY_DATA = [
    {
        Cluster: 0,
        temp_min: 5.7989,
        temp_Q1: 16.1367,
        temp_median: 18.4102,
        temp_Q3: 21.8251,
        temp_max: 29.553,
        salinity_min: 29.4597,
        salinity_Q1: 33.7904,
        salinity_median: 34.2799,
        salinity_Q3: 34.5531,
        salinity_max: 35.0808,
        dissO2_min: 64.587,
        dissO2_Q1: 165.227,
        dissO2_median: 196.93,
        dissO2_Q3: 241.883,
        dissO2_max: 279.43,
        phosphate_min: 0.03902,
        phosphate_Q1: 0.33329,
        phosphate_median: 0.51224,
        phosphate_Q3: 0.7249,
        phosphate_max: 1.5486,
        nitrate_min: 0,
        nitrate_Q1: 0.5459,
        nitrate_median: 4.0905,
        nitrate_Q3: 8.0438,
        nitrate_max: 17.8635,
        silicate_min: 0.358,
        silicate_Q1: 3.199,
        silicate_median: 6.167,
        silicate_Q3: 9.037,
        silicate_max: 29.98,
    },
    {
        Cluster: 1,
        temp_min: -0.6548,
        temp_Q1: 8.5182,
        temp_median: 8.6946,
        temp_Q3: 8.7857,
        temp_max: 14.7221,
        salinity_min: 19.9015,
        salinity_Q1: 21.2176,
        salinity_median: 21.551,
        salinity_Q3: 21.6686,
        salinity_max: 22.3833,
        dissO2_min: 0,
        dissO2_Q1: 1.268,
        dissO2_median: 3.861,
        dissO2_Q3: 10.041,
        dissO2_max: 33.861,
        phosphate_min: 2.42426,
        phosphate_Q1: 3.87982,
        phosphate_median: 4.2834,
        phosphate_Q3: 4.5347,
        phosphate_max: 5.0961,
        nitrate_min: 0,
        nitrate_Q1: 0.275,
        nitrate_median: 0.6169,
        nitrate_Q3: 1.1102,
        nitrate_max: 4.2771,
        silicate_min: 57.413,
        silicate_Q1: 88.166,
        silicate_median: 109.311,
        silicate_Q3: 124.907,
        silicate_max: 191.758,
    },
    {
        Cluster: 2,
        temp_min: -0.4111,
        temp_Q1: 7.6959,
        temp_median: 7.8378,
        temp_Q3: 8.0196,
        temp_max: 21.7296,
        salinity_min: 18.0634,
        salinity_Q1: 19.2605,
        salinity_median: 19.6275,
        salinity_Q3: 20.0112,
        salinity_max: 21.9382,
        dissO2_min: 22.768,
        dissO2_Q1: 69.453,
        dissO2_median: 109.44,
        dissO2_Q3: 156.156,
        dissO2_max: 261.57,
        phosphate_min: 0.17999,
        phosphate_Q1: 0.63469,
        phosphate_median: 0.77671,
        phosphate_Q3: 0.9128,
        phosphate_max: 2.4481,
        nitrate_min: 0,
        nitrate_Q1: 2.7372,
        nitrate_median: 3.0631,
        nitrate_Q3: 3.3908,
        nitrate_max: 4.1135,
        silicate_min: 3.875,
        silicate_Q1: 26.459,
        silicate_median: 34.292,
        silicate_Q3: 41.895,
        silicate_max: 62.747,
    },
    {
        Cluster: 3,
        temp_min: -0.1526,
        temp_Q1: 2.113,
        temp_median: 2.5359,
        temp_Q3: 3.0521,
        temp_max: 5.1292,
        salinity_min: 33.6397,
        salinity_Q1: 34.4926,
        salinity_median: 34.5795,
        salinity_Q3: 34.6165,
        salinity_max: 35.0207,
        dissO2_min: 9.103,
        dissO2_Q1: 39.768,
        dissO2_median: 64.908,
        dissO2_Q3: 88.128,
        dissO2_max: 125.993,
        phosphate_min: 2.21048,
        phosphate_Q1: 2.84701,
        phosphate_median: 2.96026,
        phosphate_Q3: 3.0735,
        phosphate_max: 3.8241,
        nitrate_min: 27.6112,
        nitrate_Q1: 40.0212,
        nitrate_median: 41.456,
        nitrate_Q3: 42.824,
        nitrate_max: 51.3815,
        silicate_min: 104.587,
        silicate_Q1: 130.571,
        silicate_median: 145.139,
        silicate_Q3: 161.028,
        silicate_max: 237.115,
    },
    {
        Cluster: 4,
        temp_min: 4.6616,
        temp_Q1: 8.8504,
        temp_median: 8.8783,
        temp_Q3: 8.9016,
        temp_max: 14.9012,
        salinity_min: 21.7183,
        salinity_Q1: 21.9118,
        salinity_median: 22.0136,
        salinity_Q3: 22.1617,
        salinity_max: 22.3938,
        dissO2_min: 0,
        dissO2_Q1: 0,
        dissO2_median: 0,
        dissO2_Q3: 0,
        dissO2_max: 0.161,
        phosphate_min: 4.96467,
        phosphate_Q1: 5.55288,
        phosphate_median: 6.05447,
        phosphate_Q3: 6.5022,
        phosphate_max: 7.0975,
        nitrate_min: 0,
        nitrate_Q1: 0,
        nitrate_median: 0.0132,
        nitrate_Q3: 0.1158,
        nitrate_max: 0.6256,
        silicate_min: 104.047,
        silicate_Q1: 132.553,
        silicate_median: 144.441,
        silicate_Q3: 183.159,
        silicate_max: 225.712,
    },
    {
        Cluster: 5,
        temp_min: -1.6145,
        temp_Q1: -1.4731,
        temp_median: -1.3544,
        temp_Q3: -0.9523,
        temp_max: 28.4842,
        salinity_min: 25.3553,
        salinity_Q1: 27.9813,
        salinity_median: 28.6712,
        salinity_Q3: 29.201,
        salinity_max: 29.6043,
        dissO2_min: 196.954,
        dissO2_Q1: 377.317,
        dissO2_median: 389.389,
        dissO2_Q3: 393.971,
        dissO2_max: 476.698,
        phosphate_min: 0.05768,
        phosphate_Q1: 0.64654,
        phosphate_median: 0.75163,
        phosphate_Q3: 0.8639,
        phosphate_max: 1.8084,
        nitrate_min: 0.0093,
        nitrate_Q1: 0.257,
        nitrate_median: 0.521,
        nitrate_Q3: 1.148,
        nitrate_max: 8.0092,
        silicate_min: 0.542,
        silicate_Q1: 4.842,
        silicate_median: 6.444,
        silicate_Q3: 9.916,
        silicate_max: 44.709,
    },
    {
        Cluster: 6,
        temp_min: -0.8526,
        temp_Q1: 7.6898,
        temp_median: 9.0227,
        temp_Q3: 12.4997,
        temp_max: 18.9814,
        salinity_min: 15.1488,
        salinity_Q1: 18.1405,
        salinity_median: 18.3086,
        salinity_Q3: 18.5412,
        salinity_max: 20.3129,
        dissO2_min: 193.938,
        dissO2_Q1: 274.099,
        dissO2_median: 289.125,
        dissO2_Q3: 297.323,
        dissO2_max: 412.134,
        phosphate_min: 0.10874,
        phosphate_Q1: 0.17973,
        phosphate_median: 0.23718,
        phosphate_Q3: 0.3479,
        phosphate_max: 1.2451,
        nitrate_min: 0.0996,
        nitrate_Q1: 0.5421,
        nitrate_median: 0.9393,
        nitrate_Q3: 1.5739,
        nitrate_max: 5.622,
        silicate_min: 5.335,
        silicate_Q1: 9.526,
        silicate_median: 12.062,
        silicate_Q3: 16.494,
        silicate_max: 55.071,
    },
    {
        Cluster: 7,
        temp_min: 0.9596,
        temp_Q1: 12.1276,
        temp_median: 16.053,
        temp_Q3: 18.5361,
        temp_max: 22.821,
        salinity_min: 7.6171,
        salinity_Q1: 8.4892,
        salinity_median: 9.1295,
        salinity_Q3: 9.8271,
        salinity_max: 10.7282,
        dissO2_min: 212.497,
        dissO2_Q1: 272.41,
        dissO2_median: 288.292,
        dissO2_Q3: 306.119,
        dissO2_max: 405.632,
        phosphate_min: 0.05271,
        phosphate_Q1: 0.10245,
        phosphate_median: 0.15347,
        phosphate_Q3: 0.2983,
        phosphate_max: 0.827,
        nitrate_min: 0.0222,
        nitrate_Q1: 0.1062,
        nitrate_median: 0.1393,
        nitrate_Q3: 0.3872,
        nitrate_max: 3.9365,
        silicate_min: 2.762,
        silicate_Q1: 4.481,
        silicate_median: 5.65,
        silicate_Q3: 7.82,
        silicate_max: 53.632,
    },
    {
        Cluster: 8,
        temp_min: 3.359,
        temp_Q1: 9.5382,
        temp_median: 10.7798,
        temp_Q3: 12.1207,
        temp_max: 18.4697,
        salinity_min: 32.933,
        salinity_Q1: 34.3476,
        salinity_median: 34.6368,
        salinity_Q3: 34.9346,
        salinity_max: 35.6295,
        dissO2_min: 167.351,
        dissO2_Q1: 230.385,
        dissO2_median: 257.131,
        dissO2_Q3: 271.636,
        dissO2_max: 318.311,
        phosphate_min: 0.14136,
        phosphate_Q1: 0.68841,
        phosphate_median: 0.84654,
        phosphate_Q3: 0.9997,
        phosphate_max: 1.6638,
        nitrate_min: 0.1763,
        nitrate_Q1: 7.9611,
        nitrate_median: 10.8763,
        nitrate_Q3: 13.3853,
        nitrate_max: 22.3923,
        silicate_min: 0.389,
        silicate_Q1: 3.233,
        silicate_median: 4.683,
        silicate_Q3: 6.605,
        silicate_max: 33.548,
    },
    {
        Cluster: 9,
        temp_min: 12.4296,
        temp_Q1: 13.6845,
        temp_median: 14.0518,
        temp_Q3: 16.5216,
        temp_max: 29.6642,
        salinity_min: 37.3344,
        salinity_Q1: 38.448,
        salinity_median: 38.7129,
        salinity_Q3: 38.8483,
        salinity_max: 41.446,
        dissO2_min: 24.364,
        dissO2_Q1: 185.637,
        dissO2_median: 196.572,
        dissO2_Q3: 228.025,
        dissO2_max: 262.139,
        phosphate_min: 0.01138,
        phosphate_Q1: 0.10585,
        phosphate_median: 0.16969,
        phosphate_Q3: 0.2353,
        phosphate_max: 1.2818,
        nitrate_min: 0,
        nitrate_Q1: 0.7804,
        nitrate_median: 4.1875,
        nitrate_Q3: 5.5243,
        nitrate_max: 20.2155,
        silicate_min: 0.303,
        silicate_Q1: 1.946,
        silicate_median: 4.455,
        silicate_Q3: 7.516,
        silicate_max: 26.857,
    },
    {
        Cluster: 10,
        temp_min: 4.5766,
        temp_Q1: 8.2492,
        temp_median: 9.507,
        temp_Q3: 11.0298,
        temp_max: 24.276,
        salinity_min: 33.6527,
        salinity_Q1: 34.6128,
        salinity_median: 34.7326,
        salinity_Q3: 34.9274,
        salinity_max: 36.9017,
        dissO2_min: 1.106,
        dissO2_Q1: 34.143,
        dissO2_median: 69.286,
        dissO2_Q3: 99.227,
        dissO2_max: 154.425,
        phosphate_min: 1.42936,
        phosphate_Q1: 1.98038,
        phosphate_median: 2.22658,
        phosphate_Q3: 2.4619,
        phosphate_max: 3.2687,
        nitrate_min: 8.0729,
        nitrate_Q1: 27.2501,
        nitrate_median: 30.3263,
        nitrate_Q3: 33.2721,
        nitrate_max: 42.6181,
        silicate_min: 7.782,
        silicate_Q1: 21.93,
        silicate_median: 29.622,
        silicate_Q3: 38.655,
        silicate_max: 94.231,
    },
    {
        Cluster: 11,
        temp_min: 8.1478,
        temp_Q1: 14.5985,
        temp_median: 16.3803,
        temp_Q3: 18.2592,
        temp_max: 21.6512,
        salinity_min: 34.1481,
        salinity_Q1: 35.1392,
        salinity_median: 35.4218,
        salinity_Q3: 35.6112,
        salinity_max: 36.4326,
        dissO2_min: 146.709,
        dissO2_Q1: 217.347,
        dissO2_median: 231.918,
        dissO2_Q3: 242.658,
        dissO2_max: 281.48,
        phosphate_min: 0.04602,
        phosphate_Q1: 0.22702,
        phosphate_median: 0.34393,
        phosphate_Q3: 0.5038,
        phosphate_max: 1.3255,
        nitrate_min: 0.0106,
        nitrate_Q1: 0.7803,
        nitrate_median: 2.5454,
        nitrate_Q3: 5.6335,
        nitrate_max: 19.5279,
        silicate_min: 0.162,
        silicate_Q1: 1.871,
        silicate_median: 2.722,
        silicate_Q3: 3.988,
        silicate_max: 17.397,
    },
    {
        Cluster: 12,
        temp_min: 0.8482,
        temp_Q1: 4.4394,
        temp_median: 4.6763,
        temp_Q3: 4.962,
        temp_max: 14.1701,
        salinity_min: 8.4607,
        salinity_Q1: 9.6792,
        salinity_median: 10.0677,
        salinity_Q3: 10.6509,
        salinity_max: 12.4773,
        dissO2_min: 8.277,
        dissO2_Q1: 44.434,
        dissO2_median: 68.974,
        dissO2_Q3: 90.398,
        dissO2_max: 145.703,
        phosphate_min: 1.47405,
        phosphate_Q1: 2.02932,
        phosphate_median: 2.33812,
        phosphate_Q3: 2.6225,
        phosphate_max: 4.4964,
        nitrate_min: 3.0603,
        nitrate_Q1: 5.0348,
        nitrate_median: 5.2835,
        nitrate_Q3: 5.7536,
        nitrate_max: 7.4279,
        silicate_min: 32.912,
        silicate_Q1: 38.585,
        silicate_median: 42.338,
        silicate_Q3: 46.449,
        silicate_max: 63.435,
    },
    {
        Cluster: 13,
        temp_min: 0.0481,
        temp_Q1: 1.533,
        temp_median: 1.7728,
        temp_Q3: 2.2079,
        temp_max: 5.3333,
        salinity_min: 33.3786,
        salinity_Q1: 34.6541,
        salinity_median: 34.6773,
        salinity_Q3: 34.6901,
        salinity_max: 34.9431,
        dissO2_min: 73.652,
        dissO2_Q1: 128.248,
        dissO2_median: 145.424,
        dissO2_Q3: 156.344,
        dissO2_max: 186.74,
        phosphate_min: 0.51844,
        phosphate_Q1: 2.45636,
        phosphate_median: 2.52144,
        phosphate_Q3: 2.6126,
        phosphate_max: 3.2826,
        nitrate_min: 24.7915,
        nitrate_Q1: 35.1492,
        nitrate_median: 36.0541,
        nitrate_Q3: 37.2699,
        nitrate_max: 47.2432,
        silicate_min: 86.128,
        silicate_Q1: 121.193,
        silicate_median: 136.632,
        silicate_Q3: 148.944,
        silicate_max: 222.144,
    },
    {
        Cluster: 14,
        temp_min: -2.0933,
        temp_Q1: 0.3678,
        temp_median: 0.9789,
        temp_Q3: 1.394,
        temp_max: 3.3818,
        salinity_min: 33.2829,
        salinity_Q1: 34.6807,
        salinity_median: 34.7063,
        salinity_Q3: 34.7217,
        salinity_max: 35.1038,
        dissO2_min: 109.68,
        dissO2_Q1: 196.269,
        dissO2_median: 206.432,
        dissO2_Q3: 217.136,
        dissO2_max: 296.566,
        phosphate_min: 0.00736,
        phosphate_Q1: 2.17982,
        phosphate_median: 2.22506,
        phosphate_Q3: 2.2664,
        phosphate_max: 2.8792,
        nitrate_min: 19.7769,
        nitrate_Q1: 31.5677,
        nitrate_median: 32.1518,
        nitrate_Q3: 32.6501,
        nitrate_max: 38.9934,
        silicate_min: 70.332,
        silicate_Q1: 101.961,
        silicate_median: 115.655,
        silicate_Q3: 123.154,
        silicate_max: 163.564,
    },
    {
        Cluster: 15,
        temp_min: 7.2346,
        temp_Q1: 8.9471,
        temp_median: 8.9913,
        temp_Q3: 9.0377,
        temp_max: 15.2176,
        salinity_min: 21.9918,
        salinity_Q1: 22.2746,
        salinity_median: 22.3117,
        salinity_Q3: 22.3333,
        salinity_max: 23.6731,
        dissO2_min: 0,
        dissO2_Q1: 0,
        dissO2_median: 0,
        dissO2_Q3: 0,
        dissO2_max: 0,
        phosphate_min: 6.6738,
        phosphate_Q1: 7.47129,
        phosphate_median: 7.80878,
        phosphate_Q3: 8.104,
        phosphate_max: 9.1505,
        nitrate_min: 0,
        nitrate_Q1: 0,
        nitrate_median: 0,
        nitrate_Q3: 0,
        nitrate_max: 0.1646,
        silicate_min: 89.259,
        silicate_Q1: 173.557,
        silicate_median: 181.026,
        silicate_Q3: 196.328,
        silicate_max: 251.933,
    },
    {
        Cluster: 16,
        temp_min: 0,
        temp_Q1: 2.5924,
        temp_median: 3.8969,
        temp_Q3: 5.4184,
        temp_max: 12.0383,
        salinity_min: 5,
        salinity_Q1: 5.0628,
        salinity_median: 5.5357,
        salinity_Q3: 5.7578,
        salinity_max: 6.141,
        dissO2_min: 290.126,
        dissO2_Q1: 369.269,
        dissO2_median: 376.872,
        dissO2_Q3: 380.037,
        dissO2_max: 390.224,
        phosphate_min: 0.04871,
        phosphate_Q1: 0.09137,
        phosphate_median: 0.13492,
        phosphate_Q3: 0.1758,
        phosphate_max: 0.594,
        nitrate_min: 0.064,
        nitrate_Q1: 1.8202,
        nitrate_median: 2.1944,
        nitrate_Q3: 5.3172,
        nitrate_max: 7.3047,
        silicate_min: 7.86,
        silicate_Q1: 13.651,
        silicate_median: 15.037,
        silicate_Q3: 27.989,
        silicate_max: 29.266,
    },
    {
        Cluster: 17,
        temp_min: 1.2668,
        temp_Q1: 3.6021,
        temp_median: 5.5837,
        temp_Q3: 7.5734,
        temp_max: 14.0587,
        salinity_min: 5.6454,
        salinity_Q1: 6.6977,
        salinity_median: 7.2949,
        salinity_Q3: 7.5406,
        salinity_max: 8.5027,
        dissO2_min: 270.143,
        dissO2_Q1: 343.405,
        dissO2_median: 349.94,
        dissO2_Q3: 354.019,
        dissO2_max: 383.769,
        phosphate_min: 0.13163,
        phosphate_Q1: 0.30797,
        phosphate_median: 0.375,
        phosphate_Q3: 0.4719,
        phosphate_max: 0.8025,
        nitrate_min: 0.121,
        nitrate_Q1: 1.4581,
        nitrate_median: 1.7945,
        nitrate_Q3: 2.2126,
        nitrate_max: 5.5774,
        silicate_min: 1.987,
        silicate_Q1: 10.666,
        silicate_median: 11.322,
        silicate_Q3: 12.549,
        silicate_max: 29.712,
    },
    {
        Cluster: 18,
        temp_min: 19.1604,
        temp_Q1: 25.5787,
        temp_median: 27.1698,
        temp_Q3: 28.1663,
        temp_max: 29.974,
        salinity_min: 32.0608,
        salinity_Q1: 34.303,
        salinity_median: 34.5645,
        salinity_Q3: 34.7504,
        salinity_max: 35.0207,
        dissO2_min: 96.064,
        dissO2_Q1: 194.888,
        dissO2_median: 199.122,
        dissO2_Q3: 204.297,
        dissO2_max: 238.891,
        phosphate_min: 0.02476,
        phosphate_Q1: 0.13759,
        phosphate_median: 0.20562,
        phosphate_Q3: 0.2861,
        phosphate_max: 1.0431,
        nitrate_min: 0,
        nitrate_Q1: 0.1602,
        nitrate_median: 0.3794,
        nitrate_Q3: 1.1273,
        nitrate_max: 12.0932,
        silicate_min: 0.358,
        silicate_Q1: 1.719,
        silicate_median: 2.7,
        silicate_Q3: 4.084,
        silicate_max: 19.187,
    },
    {
        Cluster: 19,
        temp_min: -1.4497,
        temp_Q1: 4.074,
        temp_median: 5.628,
        temp_Q3: 6.9188,
        temp_max: 13.676,
        salinity_min: 33.1375,
        salinity_Q1: 33.9206,
        salinity_median: 34.0977,
        salinity_Q3: 34.2259,
        salinity_max: 34.9992,
        dissO2_min: 182.36,
        dissO2_Q1: 273.189,
        dissO2_median: 292.077,
        dissO2_Q3: 307.515,
        dissO2_max: 341.635,
        phosphate_min: 0.7676,
        phosphate_Q1: 1.31113,
        phosphate_median: 1.46772,
        phosphate_Q3: 1.6081,
        phosphate_max: 2.1515,
        nitrate_min: 8.1931,
        nitrate_Q1: 17.6119,
        nitrate_median: 20.3357,
        nitrate_Q3: 22.7328,
        nitrate_max: 31.0136,
        silicate_min: 0,
        silicate_Q1: 5.922,
        silicate_median: 8.528,
        silicate_Q3: 12.615,
        silicate_max: 51.432,
    },
    {
        Cluster: 20,
        temp_min: 1.2124,
        temp_Q1: 3.5689,
        temp_median: 3.8663,
        temp_Q3: 4.1788,
        temp_max: 8.9726,
        salinity_min: 5.6387,
        salinity_Q1: 8.2004,
        salinity_median: 8.5287,
        salinity_Q3: 8.9597,
        salinity_max: 10.6483,
        dissO2_min: 113.692,
        dissO2_Q1: 182.951,
        dissO2_median: 226.921,
        dissO2_Q3: 263.139,
        dissO2_max: 313.113,
        phosphate_min: 0.61629,
        phosphate_Q1: 0.9513,
        phosphate_median: 1.18069,
        phosphate_Q3: 1.4477,
        phosphate_max: 2.0589,
        nitrate_min: 2.2453,
        nitrate_Q1: 3.7557,
        nitrate_median: 4.2687,
        nitrate_Q3: 4.8206,
        nitrate_max: 5.7543,
        silicate_min: 14.258,
        silicate_Q1: 21.306,
        silicate_median: 24.563,
        silicate_Q3: 29.543,
        silicate_max: 39.849,
    },
    {
        Cluster: 21,
        temp_min: 12.5844,
        temp_Q1: 20.2244,
        temp_median: 22.6799,
        temp_Q3: 24.9914,
        temp_max: 29.7349,
        salinity_min: 35.7875,
        salinity_Q1: 36.238,
        salinity_median: 36.4503,
        salinity_Q3: 36.6975,
        salinity_max: 38.1935,
        dissO2_min: 101.791,
        dissO2_Q1: 201.972,
        dissO2_median: 211.332,
        dissO2_Q3: 220.715,
        dissO2_max: 257.687,
        phosphate_min: 0.01346,
        phosphate_Q1: 0.08898,
        phosphate_median: 0.16543,
        phosphate_Q3: 0.2558,
        phosphate_max: 1.36,
        nitrate_min: 0.0066,
        nitrate_Q1: 0.1662,
        nitrate_median: 0.4926,
        nitrate_Q3: 1.7273,
        nitrate_max: 15.8548,
        silicate_min: 0.206,
        silicate_Q1: 0.981,
        silicate_median: 1.332,
        silicate_Q3: 1.965,
        silicate_max: 18.364,
    },
    {
        Cluster: 22,
        temp_min: 0.2458,
        temp_Q1: 0.8956,
        temp_median: 8.3396,
        temp_Q3: 12.7929,
        temp_max: 17.972,
        salinity_min: 12.939,
        salinity_Q1: 15.0241,
        salinity_median: 15.8933,
        salinity_Q3: 16.5508,
        salinity_max: 17.034,
        dissO2_min: 98.153,
        dissO2_Q1: 115.503,
        dissO2_median: 121.83,
        dissO2_Q3: 162.057,
        dissO2_max: 261.57,
        phosphate_min: 0.7829,
        phosphate_Q1: 1.26976,
        phosphate_median: 1.55943,
        phosphate_Q3: 1.6906,
        phosphate_max: 1.7996,
        nitrate_min: 2.6165,
        nitrate_Q1: 5.9719,
        nitrate_median: 6.2959,
        nitrate_Q3: 6.805,
        nitrate_max: 6.805,
        silicate_min: 11.602,
        silicate_Q1: 30.388,
        silicate_median: 37.143,
        silicate_Q3: 39.07,
        silicate_max: 42.379,
    },
    {
        Cluster: 23,
        temp_min: -1.8821,
        temp_Q1: -1.6818,
        temp_median: -1.5488,
        temp_Q3: -1.1932,
        temp_max: 14.9804,
        salinity_min: 30.9606,
        salinity_Q1: 31.841,
        salinity_median: 32.1936,
        salinity_Q3: 32.5864,
        salinity_max: 33.1516,
        dissO2_min: 176.675,
        dissO2_Q1: 331.922,
        dissO2_median: 352.358,
        dissO2_Q3: 368.95,
        dissO2_max: 457.505,
        phosphate_min: 0.07094,
        phosphate_Q1: 0.73794,
        phosphate_median: 0.90873,
        phosphate_Q3: 1.2206,
        phosphate_max: 2.0435,
        nitrate_min: 0,
        nitrate_Q1: 2.3093,
        nitrate_median: 3.6636,
        nitrate_Q3: 5.4706,
        nitrate_max: 15.1849,
        silicate_min: 0.634,
        silicate_Q1: 7.983,
        silicate_median: 11.087,
        silicate_Q3: 17.174,
        silicate_max: 34.053,
    },
    {
        Cluster: 24,
        temp_min: 18.6482,
        temp_Q1: 22.5177,
        temp_median: 24.6731,
        temp_Q3: 26.8733,
        temp_max: 29.5454,
        salinity_min: 34.7878,
        salinity_Q1: 35.1632,
        salinity_median: 35.3833,
        salinity_Q3: 35.634,
        salinity_max: 36.2697,
        dissO2_min: 76.014,
        dissO2_Q1: 193.573,
        dissO2_median: 203.296,
        dissO2_Q3: 212.885,
        dissO2_max: 241.427,
        phosphate_min: 0.01829,
        phosphate_Q1: 0.13039,
        phosphate_median: 0.21228,
        phosphate_Q3: 0.4422,
        phosphate_max: 1.2168,
        nitrate_min: 0.0016,
        nitrate_Q1: 0.1629,
        nitrate_median: 0.5374,
        nitrate_Q3: 3.0454,
        nitrate_max: 14.4072,
        silicate_min: 0.209,
        silicate_Q1: 1.477,
        silicate_median: 2.248,
        silicate_Q3: 3.43,
        silicate_max: 16.773,
    },
    {
        Cluster: 25,
        temp_min: -1.7574,
        temp_Q1: -1.6407,
        temp_median: -1.6039,
        temp_Q3: -1.4473,
        temp_max: 23.3195,
        salinity_min: 29.5176,
        salinity_Q1: 30.2676,
        salinity_median: 30.6769,
        salinity_Q3: 31.07,
        salinity_max: 31.6701,
        dissO2_min: 237.543,
        dissO2_Q1: 377.742,
        dissO2_median: 384.993,
        dissO2_Q3: 394.302,
        dissO2_max: 468.408,
        phosphate_min: 0.08125,
        phosphate_Q1: 0.7409,
        phosphate_median: 0.82928,
        phosphate_Q3: 0.97,
        phosphate_max: 2.0221,
        nitrate_min: 0.0069,
        nitrate_Q1: 0.5774,
        nitrate_median: 0.9989,
        nitrate_Q3: 1.6423,
        nitrate_max: 15.9047,
        silicate_min: 0.634,
        silicate_Q1: 7.309,
        silicate_median: 8.908,
        silicate_Q3: 10.485,
        silicate_max: 34.136,
    },
    {
        Cluster: 26,
        temp_min: 6.3563,
        temp_Q1: 11.317,
        temp_median: 13.5054,
        temp_Q3: 16.2818,
        temp_max: 25.4754,
        salinity_min: 33.5797,
        salinity_Q1: 34.86,
        salinity_median: 35.1431,
        salinity_Q3: 35.5069,
        salinity_max: 37.0185,
        dissO2_min: 15.312,
        dissO2_Q1: 115.968,
        dissO2_median: 139.152,
        dissO2_Q3: 166.133,
        dissO2_max: 216.42,
        phosphate_min: 0.48497,
        phosphate_Q1: 1.03176,
        phosphate_median: 1.23776,
        phosphate_Q3: 1.4681,
        phosphate_max: 2.3055,
        nitrate_min: 3.249,
        nitrate_Q1: 14.0174,
        nitrate_median: 17.1466,
        nitrate_Q3: 20.3052,
        nitrate_max: 29.9163,
        silicate_min: 1.343,
        silicate_Q1: 7.434,
        silicate_median: 10.509,
        silicate_Q3: 14.882,
        silicate_max: 56.362,
    },
    {
        Cluster: 27,
        temp_min: -1.3759,
        temp_Q1: -0.9122,
        temp_median: -0.3022,
        temp_Q3: 6.3914,
        temp_max: 22.2917,
        salinity_min: 19.9394,
        salinity_Q1: 21.6,
        salinity_median: 22.5437,
        salinity_Q3: 24.1278,
        salinity_max: 25.8063,
        dissO2_min: 175.916,
        dissO2_Q1: 280.991,
        dissO2_median: 369.738,
        dissO2_Q3: 384.538,
        dissO2_max: 410.607,
        phosphate_min: 0.06731,
        phosphate_Q1: 0.25268,
        phosphate_median: 0.52557,
        phosphate_Q3: 0.7768,
        phosphate_max: 1.6075,
        nitrate_min: 0,
        nitrate_Q1: 0.2335,
        nitrate_median: 0.5486,
        nitrate_Q3: 1.3087,
        nitrate_max: 6.002,
        silicate_min: 1.973,
        silicate_Q1: 7.105,
        silicate_median: 13.35,
        silicate_Q3: 19.453,
        silicate_max: 47.33,
    },
    {
        Cluster: 28,
        temp_min: 0.3593,
        temp_Q1: 10.3919,
        temp_median: 12.4794,
        temp_Q3: 14.4382,
        temp_max: 19.8933,
        salinity_min: 10.5767,
        salinity_Q1: 12.7293,
        salinity_median: 12.8305,
        salinity_Q3: 12.9119,
        salinity_max: 15.1618,
        dissO2_min: 144.998,
        dissO2_Q1: 274.786,
        dissO2_median: 292.962,
        dissO2_Q3: 305.3,
        dissO2_max: 409.025,
        phosphate_min: 0.06345,
        phosphate_Q1: 0.14446,
        phosphate_median: 0.17808,
        phosphate_Q3: 0.2169,
        phosphate_max: 1.4493,
        nitrate_min: 0.0033,
        nitrate_Q1: 0.0159,
        nitrate_median: 0.0447,
        nitrate_Q3: 0.1073,
        nitrate_max: 6.148,
        silicate_min: 2.152,
        silicate_Q1: 4.163,
        silicate_median: 4.816,
        silicate_Q3: 6.228,
        silicate_max: 55.071,
    },
    {
        Cluster: 29,
        temp_min: -2.093,
        temp_Q1: -0.4699,
        temp_median: -0.0548,
        temp_Q3: 1.0992,
        temp_max: 7.4066,
        salinity_min: 33.9473,
        salinity_Q1: 34.8835,
        salinity_median: 34.918,
        salinity_Q3: 34.9392,
        salinity_max: 35.5839,
        dissO2_min: 204.819,
        dissO2_Q1: 291.544,
        dissO2_median: 298.635,
        dissO2_Q3: 302.508,
        dissO2_max: 366.344,
        phosphate_min: 0.12005,
        phosphate_Q1: 0.87346,
        phosphate_median: 0.94936,
        phosphate_Q3: 1.0052,
        phosphate_max: 1.7625,
        nitrate_min: 1.7487,
        nitrate_Q1: 12.4096,
        nitrate_median: 13.4625,
        nitrate_Q3: 14.5524,
        nitrate_max: 22.1119,
        silicate_min: 0.449,
        silicate_Q1: 7.465,
        silicate_median: 9.16,
        silicate_Q3: 11.047,
        silicate_max: 36.776,
    },
    {
        Cluster: 30,
        temp_min: -1.8273,
        temp_Q1: -0.9042,
        temp_median: 4.561,
        temp_Q3: 7.1389,
        temp_max: 17.8946,
        salinity_min: 30.3865,
        salinity_Q1: 32.6404,
        salinity_median: 32.8581,
        salinity_Q3: 33.0301,
        salinity_max: 33.8855,
        dissO2_min: 90.118,
        dissO2_Q1: 283.69,
        dissO2_median: 297.096,
        dissO2_Q3: 308.09,
        dissO2_max: 361.623,
        phosphate_min: 0.14546,
        phosphate_Q1: 1.14642,
        phosphate_median: 1.40933,
        phosphate_Q3: 1.6605,
        phosphate_max: 2.4773,
        nitrate_min: 0,
        nitrate_Q1: 8.2759,
        nitrate_median: 12.2745,
        nitrate_Q3: 16.3026,
        nitrate_max: 28.7977,
        silicate_min: 0.634,
        silicate_Q1: 18.684,
        silicate_median: 25.87,
        silicate_Q3: 31.724,
        silicate_max: 75.845,
    },
    {
        Cluster: 31,
        temp_min: -2.0945,
        temp_Q1: -1.486,
        temp_median: -0.8053,
        temp_Q3: 0.7374,
        temp_max: 5.4406,
        salinity_min: 32.2157,
        salinity_Q1: 33.9104,
        salinity_median: 34.0381,
        salinity_Q3: 34.2162,
        salinity_max: 34.9451,
        dissO2_min: 222.304,
        dissO2_Q1: 304.579,
        dissO2_median: 325.494,
        dissO2_Q3: 335.482,
        dissO2_max: 389.657,
        phosphate_min: 0.98689,
        phosphate_Q1: 1.78743,
        phosphate_median: 1.88656,
        phosphate_Q3: 2.0018,
        phosphate_max: 2.9901,
        nitrate_min: 12.9667,
        nitrate_Q1: 25.6599,
        nitrate_median: 26.9902,
        nitrate_Q3: 28.5282,
        nitrate_max: 40.3715,
        silicate_min: 8.134,
        silicate_Q1: 34.559,
        silicate_median: 50.927,
        silicate_Q3: 63.739,
        silicate_max: 101.741,
    },
    {
        Cluster: 32,
        temp_min: 12.8945,
        temp_Q1: 21.6512,
        temp_median: 23.2644,
        temp_Q3: 24.3968,
        temp_max: 27.3192,
        salinity_min: 4.9901,
        salinity_Q1: 6.1672,
        salinity_median: 6.5747,
        salinity_Q3: 6.9755,
        salinity_max: 7.7632,
        dissO2_min: 215.949,
        dissO2_Q1: 283.176,
        dissO2_median: 293.114,
        dissO2_Q3: 296.44,
        dissO2_max: 360.103,
        phosphate_min: 0.05271,
        phosphate_Q1: 0.07211,
        phosphate_median: 0.08824,
        phosphate_Q3: 0.1186,
        phosphate_max: 0.2523,
        nitrate_min: 0.0222,
        nitrate_Q1: 0.0927,
        nitrate_median: 0.1394,
        nitrate_Q3: 0.1718,
        nitrate_max: 0.4376,
        silicate_min: 2.301,
        silicate_Q1: 3.369,
        silicate_median: 4.32,
        silicate_Q3: 5.566,
        silicate_max: 8.668,
    },
    {
        Cluster: 33,
        temp_min: 0.9997,
        temp_Q1: 3.9775,
        temp_median: 4.716,
        temp_Q3: 5.8029,
        temp_max: 10.4208,
        salinity_min: 33.446,
        salinity_Q1: 34.4969,
        salinity_median: 34.5528,
        salinity_Q3: 34.5939,
        salinity_max: 35.6102,
        dissO2_min: 0.818,
        dissO2_Q1: 49.142,
        dissO2_median: 75.264,
        dissO2_Q3: 95.324,
        dissO2_max: 153.343,
        phosphate_min: 1.95934,
        phosphate_Q1: 2.66379,
        phosphate_median: 2.78357,
        phosphate_Q3: 2.9318,
        phosphate_max: 3.6283,
        nitrate_min: 18.6732,
        nitrate_Q1: 36.5358,
        nitrate_median: 38.4503,
        nitrate_Q3: 40.2766,
        nitrate_max: 48.8623,
        silicate_min: 25.381,
        silicate_Q1: 72.415,
        silicate_median: 87.546,
        silicate_Q3: 100.142,
        silicate_max: 124.008,
    },
    {
        Cluster: 34,
        temp_min: -1.2031,
        temp_Q1: 0.0613,
        temp_median: 8.9404,
        temp_Q3: 9.0796,
        temp_max: 14.5431,
        salinity_min: 21.0283,
        salinity_Q1: 22.3434,
        salinity_median: 22.3586,
        salinity_Q3: 24.7447,
        salinity_max: 26.8689,
        dissO2_min: 0,
        dissO2_Q1: 0,
        dissO2_median: 0,
        dissO2_Q3: 0,
        dissO2_max: 0,
        phosphate_min: 9.21181,
        phosphate_Q1: 9.55891,
        phosphate_median: 9.83737,
        phosphate_Q3: 10.1664,
        phosphate_max: 11.3371,
        nitrate_min: 0,
        nitrate_Q1: 0,
        nitrate_median: 0,
        nitrate_Q3: 0,
        nitrate_max: 0,
        silicate_min: 125.775,
        silicate_Q1: 179.373,
        silicate_median: 186.434,
        silicate_Q3: 202.957,
        silicate_max: 238.348,
    },
    {
        Cluster: 35,
        temp_min: -2.0353,
        temp_Q1: -1.6634,
        temp_median: -1.4599,
        temp_Q3: -0.8384,
        temp_max: 10.1158,
        salinity_min: 32.867,
        salinity_Q1: 33.574,
        salinity_median: 33.9404,
        salinity_Q3: 34.2399,
        salinity_max: 34.8643,
        dissO2_min: 223.986,
        dissO2_Q1: 311.817,
        dissO2_median: 326.575,
        dissO2_Q3: 343.675,
        dissO2_max: 391.897,
        phosphate_min: 0.09507,
        phosphate_Q1: 0.54513,
        phosphate_median: 0.70647,
        phosphate_Q3: 0.8867,
        phosphate_max: 1.7625,
        nitrate_min: 0.7141,
        nitrate_Q1: 4.4587,
        nitrate_median: 5.5561,
        nitrate_Q3: 7.0209,
        nitrate_max: 22.0615,
        silicate_min: 0.654,
        silicate_Q1: 4.679,
        silicate_median: 6.593,
        silicate_Q3: 10.122,
        silicate_max: 64.435,
    },
    {
        Cluster: 36,
        temp_min: -1.0097,
        temp_Q1: 2.7485,
        temp_median: 4.0885,
        temp_Q3: 6.0911,
        temp_max: 12.3418,
        salinity_min: 33.1274,
        salinity_Q1: 34.5134,
        salinity_median: 34.8928,
        salinity_Q3: 34.955,
        salinity_max: 35.7909,
        dissO2_min: 123.734,
        dissO2_Q1: 216.395,
        dissO2_median: 235.636,
        dissO2_Q3: 247.292,
        dissO2_max: 295.398,
        phosphate_min: 0.71055,
        phosphate_Q1: 1.33686,
        phosphate_median: 1.4703,
        phosphate_Q3: 1.6407,
        phosphate_max: 2.2504,
        nitrate_min: 9.4216,
        nitrate_Q1: 19.9778,
        nitrate_median: 21.8672,
        nitrate_Q3: 24.0813,
        nitrate_max: 33.3411,
        silicate_min: 0,
        silicate_Q1: 15.371,
        silicate_median: 23.627,
        silicate_Q3: 35.238,
        silicate_max: 80.832,
    },
    {
        Cluster: 37,
        temp_min: -1.974,
        temp_Q1: 2.3109,
        temp_median: 2.8143,
        temp_Q3: 3.7433,
        temp_max: 11.2607,
        salinity_min: 32.6755,
        salinity_Q1: 34.4124,
        salinity_median: 34.5389,
        salinity_Q3: 34.6623,
        salinity_max: 35.1177,
        dissO2_min: 105.842,
        dissO2_Q1: 172.894,
        dissO2_median: 186.331,
        dissO2_Q3: 198.312,
        dissO2_max: 264.389,
        phosphate_min: 1.38211,
        phosphate_Q1: 2.11799,
        phosphate_median: 2.22904,
        phosphate_Q3: 2.3185,
        phosphate_max: 2.9926,
        nitrate_min: 14.4792,
        nitrate_Q1: 30.813,
        nitrate_median: 32.3165,
        nitrate_Q3: 33.4437,
        nitrate_max: 40.7225,
        silicate_min: 11.431,
        silicate_Q1: 46.384,
        silicate_median: 64.088,
        silicate_Q3: 76.78,
        silicate_max: 97.329,
    },
];
